import { makeAutoObservable, onBecomeObserved } from "mobx"

import { topupsApi } from "@src/shared/api"
import { NetworkCrypto, SymbolCrypto } from "@src/shared/api/generated"

export class DepositStore {
  address?: null | string = ""

  getAddress = async (network?: NetworkCrypto, symbol?: SymbolCrypto) => {
    if (network && symbol) {
      this.isLoading = true

      return topupsApi
        .getTopupAddress(network, symbol)
        .then((response) => {
          const result = response.data

          if (result.success) {
            this.address = result?.data?.address
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }

  isLoading = false

  constructor() {
    makeAutoObservable(this)

    onBecomeObserved(this, "address", this.getAddress)
  }
}
